import DocumentView from '../components/DocumentView'
import { connect } from 'react-redux'
import { fetchDocumentSessionIfNeeded } from '../actions/documentActions'
import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'

@connect(
  mapStateToProps,
  { fetchDocumentSessionIfNeeded },
  mergeProps
)
export default class DocumentViewContainer extends PureComponent {
  static propTypes = {
    company: PropTypes.object.isRequired,
    document: PropTypes.object.isRequired,
    fetchDocumentSessionIfNeeded: PropTypes.func.isRequired,
    isFetching: PropTypes.bool,
    sessionId: PropTypes.string
  }

  constructor(props) {
    super(props)

    this.handleNextPageClick = this.handleNextPageClick.bind(this)
    this.handlePageFocus = this.handlePageFocus.bind(this)
    this.handlePrevPageClick = this.handlePrevPageClick.bind(this)
    this.handleReady = this.handleReady.bind(this)

    this.state = {
      currentPage: 0,
      totalPages: 0
    }
  }

  componentWillMount() {
    const { company, document, fetchDocumentSessionIfNeeded } = this.props
    fetchDocumentSessionIfNeeded(company, document)
  }

  handleNextPageClick() {
    const { currentPage, totalPages } = this.state

    if (currentPage < totalPages) {
      this.setState({ currentPage: currentPage + 1 })
    }
  }

  handlePageFocus({ data: { page } }) {
    this.setState({ currentPage: page })
  }

  handlePrevPageClick() {
    const { currentPage } = this.state

    if (currentPage > 1) {
      this.setState({ currentPage: currentPage - 1 })
    }
  }

  handleReady({ data: { page, numPages } }) {
    this.setState({
      currentPage: page,
      totalPages: numPages
    })
  }

  render() {
    const { isFetching, sessionId } = this.props
    const { currentPage, totalPages } = this.state

    return (
      <DocumentView
        isFetching={isFetching}
        currentPage={currentPage}
        onNextPageClick={this.handleNextPageClick}
        onPageFocus={this.handlePageFocus}
        onPrevPageClick={this.handlePrevPageClick}
        onReady={this.handleReady}
        sessionId={sessionId}
        totalPages={totalPages}
      />
    )
  }
}

function mergeProps(stateProps, dispatchProps, ownProps) {
  const { company, documentSessions } = stateProps
  const { document } = ownProps
  const session = documentSessions[document.id] || {}

  return Object.assign({}, dispatchProps, {
    company,
    document,
    isFetching: session.isFetching || false,
    sessionId: session.sessionId
  })
}

function mapStateToProps(state) {
  return {
    company: state.company,
    documentSessions: state.documentSessions
  }
}



// WEBPACK FOOTER //
// ../src/containers/DocumentViewContainer.js